/**
 * Immigration domain route constants
 * Centralized route definitions to avoid hardcoded strings throughout the app
 */

const BASE = '/immigration'

export const IMMIGRATION_ROUTES = {
  BASE,
  LOGIN: `${BASE}/login`,
  FORGOT_PASSWORD: `${BASE}/forgot-password`,
  RESET_PASSWORD: `${BASE}/reset-password`,
  APPLICATION: `${BASE}/application`,
  APPLICATION_CREATE: `${BASE}/application/create`,
  E_SIGNATURE: `${BASE}/e-signature`,
  CHANGE_PASSWORD: `${BASE}/change-password`,
  CHANGE_PASSWORD_VERIFY: `${BASE}/change-password/verify`,
  STAFF_WORKLOAD: `${BASE}/staff-workload`,
  APPLICATION_DETAILS: (caseId: string) => `${BASE}/application/${caseId}`,
  APPLICATION_DOCUMENTS: (caseId: string) => `${BASE}/application/${caseId}/documents`,
  APPLICATION_INTERNAL_DOCUMENTS: (caseId: string) => `${BASE}/application/${caseId}/internal-documents`,
  STAFF: `${BASE}/staff-management`,
  CONFIGURATION: `${BASE}/configuration`,
  CONFIGURATION_CASE_TYPES: (categoryId: string)=> `${BASE}/configuration/${categoryId}`,
  CONFIGURATION_DETAIL: (categoryId: string, caseTypeId: string) => `${BASE}/configuration/${categoryId}/${caseTypeId}`,
  INVOICES: `${BASE}/invoices`,
  AUDIT_LOG: `${BASE}/audit-log`,
} as const
